var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{domProps:{"innerHTML":_vm._s(_vm.message)}})
}
var staticRenderFns = []

export { render, staticRenderFns }